export default __webpack_public_path__ + "static/media/pinterest.88de552c.png";